export default __webpack_public_path__ + "static/media/Group 3406@2x.f92ecdf8.png";